import * as React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';

const LoginButton = ({ props }: any) => {
  const { loginWithRedirect } = useAuth0();
  const onLoginRedirect = React.useCallback(() => loginWithRedirect(), [loginWithRedirect]);

  return (
    <Button variant="contained" onClick={onLoginRedirect} sx={props}>
      Log In
    </Button>
  );
};

export default LoginButton;
